import { email} from "../Rules";
import * as Yup from "yup";

export const VerifyValidationForgetPassword = Yup.object().shape({

  email: email("email", true),

});
